import { render, staticRenderFns } from "./personal-title.vue?vue&type=template&id=385c3a2d&scoped=true"
import script from "./personal-title.vue?vue&type=script&lang=js"
export * from "./personal-title.vue?vue&type=script&lang=js"
import style0 from "./personal-title.vue?vue&type=style&index=0&id=385c3a2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c3a2d",
  null
  
)

export default component.exports